import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.75 15.5a.7.7 0 0 1-.7.7h-2.231l.295.345a.7.7 0 1 1-1.065.91l-1.281-1.5a.7.7 0 0 1 0-.91l1.281-1.5a.7.7 0 1 1 1.065.91l-.295.345h2.231a.7.7 0 0 1 .7.7M10.1 8.042c-.29.38-.491.937-.491 1.583 0 .647.201 1.204.492 1.584.29.38.637.55.963.55.327 0 .674-.17.964-.55s.492-.937.492-1.584c0-.646-.201-1.203-.492-1.583-.29-.38-.637-.55-.964-.55s-.673.17-.963.55M8.91 7.13c.508-.664 1.263-1.139 2.155-1.139s1.647.475 2.156 1.14c.507.663.8 1.548.8 2.494s-.293 1.832-.8 2.495c-.509.665-1.264 1.14-2.156 1.14s-1.647-.475-2.155-1.14c-.508-.663-.8-1.548-.8-2.495 0-.946.292-1.83.8-2.495",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.23 12.509a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DecreaseDecimalIcon20.js.map